"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettingsStore = void 0;
const react_1 = require("react");
function useSettingsStore(store) {
    return (0, react_1.useSyncExternalStore)(store.subscribe, store.getSnapshot, store.getSnapshot);
}
exports.useSettingsStore = useSettingsStore;
